<template>
  <div>
    <a-card :title="`${releaseId === null ? '创建' : '编辑'}发布评审`">
      <div class="release-create">
        <a-spin :spinning="spinning">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item label="标题" prop="release_title">
                  <a-input v-model="form.release_title" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="发布类型" prop="release_type">
                  <a-select v-model="form.release_type" placeholder="请选择发布类型">
                    <a-select-option v-for="item in releaseTypeOptions" :key="item" :value="releaseTypes[item].value">
                      {{ releaseTypes[item].label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="发布环境" prop="release_env">
                  <a-select v-model="form.release_env" disabled placeholder="请选择发布环境">
                    <a-select-option v-for="(releaseEnv, index) in releaseEnvs" :key="index" :value="releaseEnv.value">
                      {{ releaseEnv.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item v-if="![13, 16, 19].includes(templateId)" label="关联需求" prop="story_list" :rules="{ required: [1].includes(form.release_type) && ![13, 16].includes(templateId), message: '关联需求不能为空' }">
                  <requirement-relation-modal v-model="form.story_list" :story-list="storyList" :workflow_id="workflowId" :template-id="templateId" @selected-change="selectedReqChange" />
                </a-form-model-item>
              </a-col>
              <a-col v-if="![4].includes(form.release_type)" :span="24">
                <a-form-model-item label="关联缺陷" prop="bug_list" :rules="{ required: [2].includes(form.release_type) && ![13, 16].includes(templateId), message: '关联缺陷不能为空' }">
                  <issue-relation-modal v-model="form.bug_list" :bug-list="bugList" :status="['3']" />
                </a-form-model-item>
              </a-col>
              <!-- 去除关联缺陷还需要关联任务的限制 -->
              <a-col v-if="[13, 16, 19].includes(templateId) && form.release_type == 1" :span="24">
                <a-form-model-item
                  label="关联任务"
                  prop="task_list"
                  :rules="{
                    required: [1].includes(form.release_type),
                    message: '关联任务不能为空且只能关联1条',
                    validator: taskValidator
                  }"
                >
                  <task-relation-modal v-model="form.task_list" :task-list="taskList" :template-id="templateId" />
                </a-form-model-item>
              </a-col>
              <!-- 集成发布流程可同时关联多个任务和多个需求 -->
              <a-col v-if="[20].includes(templateId) && form.release_type == 5" :span="24">
                <a-form-model-item label="关联任务" prop="task_list">
                  <task-relation-modal v-model="form.task_list" :task-list="taskList" :template-id="templateId" />
                </a-form-model-item>
              </a-col>
              <a-col v-if="[4].includes(form.release_type)" :span="24">
                <a-form-model-item label="关联问题" prop="problem_list" :rules="{ required: [4].includes(form.release_type) && ![13, 16].includes(templateId), message: '关联问题不能为空' }">
                  <problem-relation-modal v-model="form.problem_list" :problem-list="problemList" :status="['3']" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item label="发布服务">
                  <service-from v-model="form.services" :source-data:="form.services" :project-id="projectId" :template-id="templateId"@change="servicesChange" />
                  <a-checkbox :checked="form.is_recommend_value" @change="form.is_recommend_value = !form.is_recommend_value"> 配置是否使用推荐值, 仅对新增key有效 </a-checkbox>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item label="发布内容" prop="content">
                  <vditor-editor v-model="form.content" :height="200" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="数据变更"
                  prop="sql_address"
                  :rules="{
                    trigger: 'blur',
                    required: dataChangeServices.length > 0,
                    message: '您勾选了数据变更，请填写数据变更内容'
                  }"
                >
                  <vditor-editor v-model="form.sql_address" :height="200" />
                </a-form-model-item>
              </a-col>
              <a-col v-if="false" :span="24">
                <a-form-model-item label="备注信息" prop="workflow_type">
                  <a-textarea v-model="form.description" :auto-size="{ minRows: 3 }" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
        <div class="release-submit">
          <a-button v-tc="{ name: '保存发布评审' }" type="primary" :loading="loading" @click="onSubmit()"> 保存 </a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>
<script>
import { releaseEnvs, releaseTypes, serviceTypes } from '@/utils/dictionary';
import { workflowReleaseSave, workflowReleaseLatest, workflowReleaseDetail, getServicesByRequirement } from '@/api/project/workflow';

import VditorEditor from '@/components/VditorEditor';
import ServiceFrom from '@/pages/project/workflow/release/components/ServiceFrom';
import TaskRelationModal from '@/pages/project/workflow/release/components/TaskRelationModal';
import IssueRelationModal from '@/pages/project/workflow/release/components/IssueRelationModal';
import ProblemRelationModal from '@/pages/project/workflow/release/components/ProblemRelationModal';
import RequirementRelationModal from '@/pages/project/workflow/release/components/RequirementRelationModal';

export default {
  components: { VditorEditor, ServiceFrom, IssueRelationModal, ProblemRelationModal, RequirementRelationModal, TaskRelationModal },
  data() {
    return {
      spinning: false,
      releaseEnvs,
      releaseTypes,
      serviceTypes,
      loading: false,
      addVisible: false,
      users: {},
      modifyIndex: null,
      selectedServices: [],
      storyList: {},
      bugList: {},
      taskList: {},
      problemList: {},
      dataChangeServices: [],
      releaseId: parseInt(this.$route.query.releaseId) || null,
      projectId: parseInt(this.$route.params.project_id) || null,
      workflowId: parseInt(this.$route.query.workflowId) || null,
      releaseTypeOptions: [],
      form: {
        release_title: '',
        release_env: 2,
        release_type: null,
        workflow_id: parseInt(this.$route.query.workflowId) || null,
        project_id: parseInt(this.$route.params.project_id) || null,
        services: [],
        bug_list: [],
        task_list: [],
        story_list: [],
        problem_list: [],
        is_recommend_value: false
      },
      rules: {
        release_title: [{ required: true, message: '发布评审标题不能为空', trigger: 'blur' }],
        release_env: [{ required: true, message: '发布环境不能为空', trigger: 'blur' }],
        release_type: [{ required: true, message: '发布类型不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '发布内容不能为空', trigger: 'blur' }]
      },
      templateId: null
    };
  },
  // computed: {
  //   dataChangeServices() {
  //     return Array.isArray(this.form.services) ? this.form.services.filter(item => item.data_change.filter(c => c !== 'no_change').length > 0) : [];
  //   }
  // },
  created() {
    if (this.releaseId !== null) {
      this.getWorkflowReleaseDetail();
    } else {
      this.getWorkflowReleaseLatest();
    }
  },
  methods: {
    taskValidator(rule, value, callback) {
      if (value.length !== 1) {
        callback(new Error('关联任务不能为空且只能关联1条'));
      }
      callback();
    },
    textValidate(rule, value, callback) {
      if (value.trim() === '') {
        callback('xxxx');
        // callback();
      }
    },

    // 获取工作流发布评审详情
    getWorkflowReleaseDetail() {
      this.spinning = true;
      workflowReleaseDetail({ project_id: this.projectId, release_id: this.releaseId })
        .then(res => {
          this.form = {
            ...this.form,
            ...res.data,
            release_env: 2,
            release_type: res.data.release_type.value
          };
          const service_list = res.data.service_list;
          this.form.services = service_list.map(item => {
            return {
              ...item,
              service_type: item.service_type.value,
              developers: item.developers.map(developer => {
                return developer.id;
              })
            };
          });
          this.templateId = res.data.workflow_template.id;
          this.setReleaseTypeOptions(res.data.workflow_template.release_type_options);
          // 处理已关联的需求列表信息
          this.form.story_list = res.data.story_list.map(item => {
            this.$set(this.storyList, item.id, { id: item.id, key: item.key, title: item.title, status: item.status });
            return item.id;
          });
          // 处理已关联的缺陷列表信息
          this.form.bug_list = res.data.bug_list.map(item => {
            this.$set(this.bugList, item.id, { id: item.id, key: item.key, title: item.title, status: item.status });
            return item.id;
          });
          // 处理已关联的任务列表信息
          this.form.task_list = res.data.task_list.map(item => {
            this.$set(this.taskList, item.id, { id: item.id, key: 'TS-' + item.id, name: item.name, status: item.status });
            return item.id;
          });
          // 处理已关联的问题列表信息
          this.form.problem_list = res.data.problem_list.map(item => {
            this.$set(this.problemList, item.id, { id: item.id, key: 'PB-' + item.id, name: item.name, status: item.status });
            return item.id;
          });
          this.spinning = false;
          this.dataChangeServices = Array.isArray(this.form.services) ? this.form.services.filter(item => item.data_change.filter(c => c !== 'no_change').length > 0) : [];
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    selectedReqChange(requirements) {
      if (this.templateId === 17 || this.team_id === 17) {
        getServicesByRequirement({ requirements: requirements }).then(res => {
          res.data.items.forEach(item => {
            if (!this.selectedServices.includes(item.service_id)) {
              this.selectedServices.push(item.service_id);
              this.form.services.push({
                ...item,
                service_type: item.service_type.value,
                developers: item.developers.map(developer => {
                  return developer.id;
                })
              });
            }
          });
        });
      }
    },

    getWorkflowReleaseLatest() {
      workflowReleaseLatest(this.form).then(res => {
        this.form.services = res.data.services.map(item => {
          return {
            ...item,
            service_type: item.service_type.value,
            developers: item.developers.map(developer => {
              return developer.id;
            })
          };
        });
        this.setReleaseTypeOptions(res.data.workflow_template.release_type_options);
        this.form.release_title = res.data.release_title;
        this.templateId = res.data.workflow_template.id;
      });
    },

    setReleaseTypeOptions(value) {
      this.releaseTypeOptions = value;
      if (value.length === 1) {
        this.form.release_type = value[0];
      }
    },

    /**
     * 保存发布评审
     * @param {*} action
     */
    saveRelease(action) {
      this.loading = true;
      workflowReleaseSave({ ...this.form, action: action })
        .then(() => {
          this.$message.success('保存成功');
          this.loading = false;
          if (this.workflowId) {
            this.$router.push({
              name: 'page:project:workflow:detail',
              query: { workflowId: this.workflowId }
            });
          } else if (window.history.length > 2) {
            this.$router.go(-1);
          } else {
            this.$router.push({
              name: 'page:project:workflow:release:detail',
              query: { releaseId: this.releaseId }
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 点击保存按钮
     * @param {*} action
     */
    onSubmit(action) {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.services.length === 0) {
            const self = this;
            this.$confirm({
              title: '确认',
              content: '当前未添加服务，是否继续提交？',
              okText: '无需服务',
              okType: 'primary',
              cancelText: '去添加服务',
              onOk() {
                self.saveRelease(action);
              }
            });
          } else {
            this.saveRelease(action);
          }
        }
      });
    },
    servicesChange(val) {
      this.dataChangeServices = Array.isArray(val) ? val.filter(item => item.data_change.filter(c => c !== 'no_change').length > 0) : [];
    }
  }
};
</script>
<style lang="less">
.release-create {
  .ant-form-item {
    margin-bottom: 16px;

    .ant-form-item-label {
      line-height: 28px;
    }
  }
}

.service-card {
  .ant-card-body {
    padding: 12px;
  }
}
</style>
<style lang="less" scoped>
.release-create {
  width: 960px;
  margin: 0 auto;
}

.release-submit {
  text-align: center;
  .ant-btn {
    width: 120px;
  }
}

.add-service-card {
  height: 95px;
  text-align: center;
  border: 1px dashed rgb(207, 207, 207);

  .add-service-card_button {
    line-height: 71px;
  }
}

.service-card {
  margin: 4px 0;

  .service-card-header {
    display: block;

    .service-card-header_name {
      display: inline-block;
      height: 24px;
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 24px;
      vertical-align: top;
    }

    .service-card-header_action {
      height: 24px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 16px;
      float: right;
    }
  }

  .service-card-content {
    margin-top: 4px;
    display: block;

    .service-card-content_value {
      margin-left: 8px;
    }
  }

  .service-card-footer {
    display: block;

    .service-card-footer_value {
      margin-left: 8px;
    }
  }

  .service-card_lable {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    font-size: 14px;
  }
}
</style>
